// extracted by mini-css-extract-plugin
module.exports = {"container":"_1aZ362mDffj_S4BqLorxMq","avatar":"gfhJOhyQul8lRxu_YZPJA","name":"_1Bx-9fUfE2aAXCpu5g9kSD","description":"_1x9Cse5apcxlMrCWo-XOte"};